<div
  bsModal
  #loginModal="bs-modal"
  class="modal fade"
  [config]="{ ignoreBackdropClick: true, keyboard: false }"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">Login</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="onCancelLogin()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <alert type="warning" *ngIf="eventMessage">{{ eventMessage }}</alert>

        <div class="row">
          <div class="col-md-6">
            <form
              name="form"
              (ngSubmit)="f.form.valid && login()"
              #f="ngForm"
              novalidate
            >
              <div
                class="form-group"
                [ngClass]="{ 'has-error': !username.valid }"
              >
                <label for="loginUsername">Username</label>
                <input
                  type="text"
                  class="form-control"
                  id="loginUsername"
                  name="username"
                  autocomplete="username"
                  [(ngModel)]="model.username"
                  #username="ngModel"
                  required
                />
              </div>
              <div
                class="form-group"
                [ngClass]="{ 'has-error': !password.valid }"
              >
                <label for="password">Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  name="password"
                  autocomplete="current-password"
                  [(ngModel)]="model.password"
                  #password="ngModel"
                  required
                />
              </div>
              <div class="form-group">
                <button
                  [disabled]="loading || !f.form.valid"
                  class="btn btn-primary"
                >
                  Login</button
                >&nbsp;
                <img
                  *ngIf="loading"
                  src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                />
              </div>
              <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
